import React, { useEffect, useState } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { Input, Icon, Tooltip, Card, Table, message } from 'antd';
import {ColumnProps} from 'antd/lib/table/interface'
import { getDomainList, getDomainPool, getRecommendedDomain } from '../../../../api/multiDomain';
import { formatTime } from '../../../../utils/format';
import { DOMAIN_STATUS } from '../../../../constants/multiDomain';
import useFetchDomains from '../../hooks/useFetchDomains';
import './style.less';

interface DomainListItem {
  domain: string,
  expireTime: number,
  status: 'ONLINE' | 'BANNED' | 'FLOOD_CONTROL',
  dayPvLimit: number
}

interface DomainPool {
  domainAvailableCount: number,
  domainFloodControlCount: number,
  domainTotalCount: number,
  domainExpire: number,
  domainLimitPV: number
}

const clsPrefix = "md-survey";
const columns:ColumnProps<DomainListItem>[] = [
  {
    title: '域名',
    key: 'domain',
    dataIndex: 'domain',
  },
  {
    title: '24小时微信内pv',
    key: 'dayPvLimit',
    dataIndex: 'dayPvLimit',
  },
  {
    title: '过期时间',
    key: 'expireTime',
    dataIndex: 'expireTime',
    render: (expireTime) => formatTime(expireTime, 'YYYY年MM月DD日 HH:mm:ss')
  },
  {
    title: '域名状态',
    key: 'status',
    dataIndex: 'status',
    align: 'center',
    render: (status) => <div style={( status !== 'ONLINE') ? { color: '#EC5454' } : {}}>{DOMAIN_STATUS[status]}</div>
  }
];

const iconStyle = {
  color: 'rgba(0,0,0,0.4)',
  cursor:'pointer',
};

const Survey:React.FC<{
  userId: string
}> = ({userId = ''}) => {
  const [ domainPoolInfo, setDomainPoolInfo ] = useState<DomainPool>({
    domainAvailableCount: 0,
    domainFloodControlCount: 0,
    domainTotalCount: 0,
    domainExpire: 0,
    domainLimitPV: 0,
  });
  const [ recommendedDomain, setRecommendedDomain ] = useState<string>()

  // 域名列表
  const {
    items: domainList,
    total,
    changeQuerys,
    loading
  } = userId && useFetchDomains<DomainListItem>(getDomainList, {
    page: 1,
    querys: {
      userId
    }
  })


  useEffect(() => {
    // 域名池信息
    if (userId) {
      // @ts-ignore
      getDomainPool(userId).then((data: DomainPool) => {
        setDomainPoolInfo(data);
      })
    }

    recommendDomain()
  }, [userId])

  function recommendDomain() {
    if (userId) {
      // @ts-ignore
      getRecommendedDomain(userId).then((data: {
        domain: string
      }) => {
        setRecommendedDomain(data.domain)
      }).catch(() => {
        setRecommendedDomain('暂无推荐域名')
      })
    }
  }

  return (
    <div className={clsPrefix}>

      <div className={`${clsPrefix}__recommend`}>
        <div className={`${clsPrefix}__recommend--title`}>推荐域名</div>
        <div className={`${clsPrefix}__recommend--top`}>
          <div className={`${clsPrefix}__recommend--opt`}>
            <Input
              className={`${clsPrefix}__recommend--input`}
              value={recommendedDomain || "暂无推荐域名"}
            />
            <CopyToClipboard text={recommendedDomain}>
              <span onClick={() => message.success('复制成功')}>复制</span>
            </CopyToClipboard>
            <span onClick={recommendDomain}>换一个</span>
            <Tooltip title="点击查看如何通过接口获取推荐域名" placement="right">
              <Icon type="question-circle" style={iconStyle} />
            </Tooltip>
          </div>
          <p>推荐同时使用多个域名，减少单个域名流量，避免域名被防洪</p>
        </div>
        <div className={`${clsPrefix}__recommend--link`}>点击链接查看最佳实践</div>
      </div>

      <div className={`${clsPrefix}__detail`}>
        <div className={`${clsPrefix}__detail--title`}>
          域名池信息
        </div>
        <div className={`${clsPrefix}__detail--content`}>
          <Card style={{ width: 300, marginRight: 24 }} >
            <p>可用域名个数：{domainPoolInfo.domainAvailableCount}个</p>
            <p>防洪域名个数：{domainPoolInfo.domainFloodControlCount}个</p>
          </Card>
          <Card style={{ width: 300 }} >
            <p>
              固定域名池大小：{domainPoolInfo.domainTotalCount}个
              <Tooltip title="联系客服快站哥(微信:kuaizhange)调大域名池或反馈更多需求" placement="right">
                <Icon type="question-circle" style={{...iconStyle, marginLeft: '10px'}} />
              </Tooltip>
            </p>
            <p>域名有效期：{domainPoolInfo.domainExpire}小时</p>
            <p>防洪规则：24小时微信内pv超过{domainPoolInfo.domainLimitPV}</p>
          </Card>
        </div>
      </div>

      <div className={`${clsPrefix}__list`}>
        <div className={`${clsPrefix}__list--title`}>
          <span>域名列表</span>
          <Tooltip title="点击查看如何通过接口拉取域名列表" placement="right">
            <Icon type="question-circle" style={iconStyle} />
          </Tooltip>
        </div>
        <div className={`${clsPrefix}__list--content`}>
          <Table 
            columns={columns}
            dataSource={domainList}
            loading={loading}
            pagination={{
              pageSize: 10,
              total,
              onChange: (pageNum) => changeQuerys({
                page: pageNum
              }),
              showQuickJumper: true,
              // hideOnSinglePage: true
            }}
          />
        </div>
      </div>

    </div>
  )
}

export default Survey;